import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { LobbyState } from '../state/lobby.state';
import { filter, map, take, tap, timeout } from 'rxjs';
import { of } from 'rxjs';

let hadUser = false;  // module-scoped: persists across guard invocations within a session

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  if (hadUser || store.selectSnapshot(LobbyState.currentUser)) {
    hadUser = true;
    return true;
  }

  return store.select(LobbyState.currentUser).pipe(
    tap((u) => { if (u) hadUser = true; }),
    filter((u) => u !== null),
    map(() => true),
    timeout({ first: 10_000, with: () => of(router.parseUrl('/error')) }),
    take(1),
  );
};
